import React, { useState } from 'react';
import '../assets/css/LoginScreen_QRInvite.css';
import background from '../assets/img/background.png'; // usa uma imagem de fundo temática (ex: convites, flores, dourado)
import logo from '../assets/img/invite.png'; // novo logo do QR Invite
import api from '../api/Api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

const LoginScreen_QRInvite = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [errors, setErrors] = useState({
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const validateForm = () => {
    const newErrors = {
      email: '',
      password: ''
    };

    if (!formData.email) {
      newErrors.email = 'E-mail é obrigatório';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'E-mail inválido';
    }

    if (!formData.password) {
      newErrors.password = 'Senha é obrigatória';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Senha deve ter pelo menos 6 caracteres';
    }

    setErrors(newErrors);
    return !newErrors.email && !newErrors.password;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("loginTime");
      localStorage.removeItem("perfil");

      const dados = { email: formData.email, password: formData.password };
      const response = await api.Login(dados);

      if (response.success) {
        localStorage.setItem("token", JSON.stringify(response.user));
        localStorage.setItem("loginTime", Date.now());
        localStorage.setItem("perfil", response.user.perfil);


        

        toast.success('Bem-vindo ao QR Invite');
        setTimeout(() => navigate("/convites"), 2000);
      } else {
        toast.error(response.message || 'Erro ao fazer login');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erro no servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="qr-login-container">
      <ToastContainer position="top-right" />
      <div 
        className="qr-login-bg"
        style={{ backgroundImage: `url(${background})` }}
      ></div>
      <div className="qr-login-overlay"></div>

      <div className="qr-login-card animate-fade">
        <div className="qr-logo-container">
          <img src={logo} alt="QR Invite Logo" className="qr-logo" />
          <h2 className="qr-title">QR Invite</h2>
          <p className="qr-subtitle">Gerencie seus convites com elegância</p>
        </div>

        <form onSubmit={handleSubmit} className="qr-login-form" noValidate>
          <div className="input-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="E-mail"
              className={`qr-input ${errors.email ? 'error' : ''}`}
              disabled={loading}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="input-group password-group">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Senha"
              className={`qr-input ${errors.password ? 'error' : ''}`}
              disabled={loading}
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </span>
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          <button 
            type="submit" 
            className={`qr-button ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>

          <div className="qr-footer">
            <a href="#" className="qr-forgot">Esqueceu sua senha?</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen_QRInvite;
